import type * as React from 'react';

import { Link } from '@/atoms/Link';
import type { FeedItemType } from '@/types';
import { formatLinkString } from '@/utils/formatLinkString';
import { getBodyHttpRegex } from '@/utils/getHttpRegex';
import { getStringFromHTML } from '@/utils/getStringFromHTML';

export const getLinkBody = (result: FeedItemType): React.ReactNode => {
  const link = result.link;
  if (!link) {
    return null;
  }

  if (Array.isArray(link)) {
    return <Link href={link[0]}>{link[0]}</Link>;
  }

  return <Link href={link}>{link}</Link>;
};

export const getBody = (
  result: FeedItemType,
  key: keyof FeedItemType = 'plain_text'
): React.ReactNode => {
  const { link } = result;
  let body = result[key];

  if (!body && link) {
    return getLinkBody(result);
  }

  const httpRegex = getBodyHttpRegex();
  if (typeof body === 'string') {
    const isLink = body.match(httpRegex);
    body = removeLeadingB(getStringFromHTML(body));

    if (
      result.source_type &&
      !['rss', 'website'].includes(result.source_type.toLowerCase())
    ) {
      body = `${body.split(' ').slice(0, 100).join(' ')}...`;
    }

    if (isLink) return <Link href={body}>{body}</Link>;

    return formatLinkString(body);
  }
};

export const removeLeadingB = (body: string): string => {
  let newBody = body;
  const extractedBody = /^(?:b')?([\s\S]*)/i.exec(body);
  if (extractedBody && extractedBody.length > 1) {
    [, newBody] = extractedBody;
  }
  return newBody;
};
